import { render, staticRenderFns } from "./deleteAccountForm.vue?vue&type=template&id=0101c9fe"
import script from "./deleteAccountForm.vue?vue&type=script&lang=js"
export * from "./deleteAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports